import React, { useState } from 'react';
import img1 from './sliderImg/cloud.jpg'
import img2 from './sliderImg/lamb.jpeg'
import img3 from './sliderImg/mountian.jpeg'
import img4 from './sliderImg/cliff.jpeg'


function Slider3() {
    // Declare a new state variable, which we'll call "count"
    let [count, setCount] = useState(1)

    if (count < 1){

        setCount(4)
    }

    if (count > 4){

        setCount(1)
    }

    let img = img1



   if (count === 2){
        img = img2;
   }
   else{

   }

   if(count === 3){
       img = img3;

   }
   else{

   }

    if(count === 4){
        img = img4;

    }
    else{

    }


    let findImg = () =>{
        console.log(img)
    }

    return (
        <div className={'ImgSlide'}>
            <>
                <div className={"ButtonBox"}>
                    <ul>
                        <li><button className={'Button-Left'} onClick={() => setCount(count - 1)}/></li>
                        <li><button className={'invis-button'} onClick={findImg}/></li>
                        <li><button className={'Button-Right'} onClick={() => setCount(count + 1)}/></li>
                    </ul>


                </div>
                <img src={img} alt={'slide'} className={'Slide'}/>
            </>

            <ul className={"QueueBox"}>
                <li><div id={'qb1'}  className={"queueButtons"}/></li>
                <li><div id={'qb2'} className={"queueButtons"}/></li>
                <li><div id={'qb3'} className={"queueButtons"}/></li>
                <li><div id={'qb4'} className={"queueButtons"}/></li>
            </ul>
        </div>
    );
}

export default Slider3